module.exports = __webpack_public_path__ + "static/media/phone-rotary.1faf8af8.svg";